import { useEffect } from 'react';
import { toast } from 'sonner';
import { skipWaitingAndReload } from '../../../serviceWorkerRegistration';

export function SWUpdatePrompt({ registration }) {
  useEffect(() => {
    if (!registration) return;

    const handleUpdate = () => {
      skipWaitingAndReload(registration);
    };

    toast.info('Nova versão disponível!', {
      description: 'Clique em Atualizar para aplicar a nova versão.',
      duration: Infinity,
      action: {
        label: 'Atualizar',
        onClick: handleUpdate,
      },
    });
  }, [registration]);

  return null;
}
